const crypto = require('crypto-js')

/**
 * @description function to encrypt
 * @param {Any} data
 * @param {String} key
 * @param {Object} options
 * @returns string
 */
const encrypt = (data, key, { encodeKey = true } = {}) => {
  let cryptoKey = key
  if (encodeKey) cryptoKey = Buffer.from(key).toString('base64')
  return crypto.AES.encrypt(JSON.stringify(data), cryptoKey).toString()
}

/**
 * WRAPPER
 * @description function to decrypt
 * @param {Any} data
 * @param {String} key
 * @param {Object} options
 * @returns any
 */
const decrypt = (data, key, { encodeKey = true } = {}) => {
  try {
    let cryptoKey = key
    if (encodeKey) cryptoKey = Buffer.from(key).toString('base64')
    const bytes = crypto.AES.decrypt(data, cryptoKey)
    const decrypted = bytes.toString(crypto.enc.Utf8)
    return JSON.parse(decrypted)
  } catch (e) {
    return data
  }
}

/**
 * WRAPPER
 * @description function to hash one or two elements together
 * @param {String} a element to hash
 * @param {String} b (optional) element to concat and hash
 * @returns string
 */
const hash = (a, b = '') => {
  const encrypted = crypto.SHA256(a + b)
  return encrypted.toString()
}

module.exports = {
  encrypt,
  decrypt,
  hash,
}
